export default __webpack_public_path__ + "static/media/logo_devscript.4ae6e054.png";